export default __webpack_public_path__ + "static/media/a-tone.e69db03d.mp3";